import React from 'react';
import styled from 'styled-components';

import CircularProgress from '@material-ui/core/CircularProgress';

const ProgressWrapper = styled.div`
  text-align: center;
  padding: 40px;
`;

const CircularLoader = ({ ...other }) => (
  <ProgressWrapper {...other}>
    <CircularProgress />
  </ProgressWrapper>
);

export default CircularLoader;
